// Open- en dichtklappen voor <transition> en <transition-group> (met :css="false").
// Op hoogte animeren kan niet met alleen CSS als de hoogte vooraf onbekend is; de Web Animations API wel.

export const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const animate = (element, keyframes, options, done) => {
    if(reducedMotion() || typeof element.animate !== 'function') {
        return done();
    }

    element.style.overflow = 'hidden';
    element.animate(keyframes, {duration: 320, easing: 'cubic-bezier(.2, .8, .2, 1)', ...options}).onfinish = () => {
        element.style.overflow = '';
        done();
    };
};

/**
 * Klapt een element open vanaf hoogte 0, met een lichte fade.
 */
export const expand = (element, done) => {
    const style = getComputedStyle(element);

    animate(element, [
        {height: '0px', opacity: 0, paddingTop: '0px', paddingBottom: '0px', marginTop: '0px', marginBottom: '0px'},
        {height: element.offsetHeight + 'px', opacity: 1, paddingTop: style.paddingTop, paddingBottom: style.paddingBottom, marginTop: style.marginTop, marginBottom: style.marginBottom}
    ], {}, done);
};

/**
 * Klapt een element dicht tot hoogte 0, zodat wat eronder staat soepel opschuift.
 */
export const collapse = (element, done) => {
    const style = getComputedStyle(element);

    animate(element, [
        {height: element.offsetHeight + 'px', opacity: 1, paddingTop: style.paddingTop, paddingBottom: style.paddingBottom, marginTop: style.marginTop, marginBottom: style.marginBottom},
        {height: '0px', opacity: 0, paddingTop: '0px', paddingBottom: '0px', marginTop: '0px', marginBottom: '0px'}
    ], {duration: 260, easing: 'ease-in'}, done);
};
